export default {
  noHasData: (state) => {
    return !state.hasError && !state.extract.length;
  }
};
